export const enum Environment {
  // The strings here are lowercase, since some JS dependencies may rely on
  // those values.
  DEVELOPMENT = 'development',
  TESTING = 'test',
  PRODUCTION = 'production',
}
